<ion-app>
  <div class="logo-container">
      <app-logo />
  </div>
 
  <ion-router-outlet></ion-router-outlet>
</ion-app>
